import { FC } from 'react'
import { sortOptionsType } from '../../../data/sortOptionItems'

export type SelectType = {
  id: string
  autoComplete: string
  label: string
  state: any
  setState: any
  options: JSX.Element[]  | JSX.Element
}

const SelectBox: FC<SelectType> = (props) => {
  const { label, state, setState, options } = props
  return (
    <span className="me-2">
      <span>{label}: </span>
      <select
        value={state}
        onChange={(e) => {
          setState(e.target.value as sortOptionsType)
        }}
      >
        {options}
      </select>
    </span>
  )
}

export default SelectBox
